import { Action } from '@ngrx/store';
import { CommandResult } from './command-result';

export const MUTATION_REQUEST = '[GraphQL] MUTATION_REQUEST';
export const MUTATION_SUCCESS = '[GraphQL] MUTATION_SUCCESS';
export const MUTATION_ERROR = '[GraphQL] MUTATION_ERROR';
export const MUTATION_EFFECT = '[GraphQL] MUTATION_EFFECT';

export class MutationRequest implements Action {
  public readonly type = MUTATION_REQUEST;
  public readonly timestamp = performance.now();
  constructor(
    public readonly name: string,
    public readonly operationId: string,
    public readonly variables?: any,
  ) {}
}

export class MutationSuccess implements Action {
  public readonly type = MUTATION_SUCCESS;
  public readonly timestamp = performance.now();
  constructor(
    public readonly name: string,
    public readonly operationId: string,
    public readonly result: CommandResult,
  ) {}
}

export class MutationError implements Action {
  public readonly type = MUTATION_ERROR;
  public readonly timestamp = performance.now();
  constructor(
    public readonly name: string,
    public readonly operationId: string,
    public readonly result?: CommandResult,
  ) {}
}
export class MutationEffect implements Action {
  public readonly type = MUTATION_EFFECT;
  public readonly timestamp = performance.now();
  constructor(public readonly operationId: string) {}
}

export type All = MutationRequest | MutationSuccess | MutationError | MutationEffect;
